import { render, staticRenderFns } from "./KpiSettingGenerateStaff.vue?vue&type=template&id=ce2d86aa"
import script from "./KpiSettingGenerateStaff.vue?vue&type=script&lang=js"
export * from "./KpiSettingGenerateStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports